export default __webpack_public_path__ + "static/media/frontdesk-bill.7338a147.jpg";